<ng-container>
  <div class="mb-[12px]" *ngIf="!isFromVault && !isFromManageVault">
    <div class="m-0 flex items-start flex-col gap-[8px]">
      <span class="text-[#53565B] text-xl font-semibold font-open-sans">
        Manage <span class="text-[#25508E] font-bold">Members</span> for
        <span class="text-[#25508E] font-bold">{{ userObject.nick_name ?? personalVaultName ?? stateObject.name | titlecase }}’s Vault</span>
      </span>

      <span class="text-[#18191C] font-open-sans font-normal text-sm">
        Members will see this vault in their ‘My Vaults’ section, and will have the ability to add, edit, and remove items from this vault.
      </span>
    </div>
  </div>

  <!-- Search Connection -->
  <div class="form-group form-main form-group-overrides w-full mb-0">
    <div class="div-group w-full" style="display: flex; justify-content: center; align-items: center">
      <div class="w-full" *ngIf="allUserConnections && allUserConnections.length > 0">
        <manage-users
          [data]="allUserConnections"
          placeHolder="Search Connections"
          (selectConnectedUser)="selectConnectedUser($event)"
          [selectedUsers]="nonProfessionalUsers"
          [isBalanceSheetMember]="true"
          [isShowFooter]="isShowFooter"
          [isInputFullWidth]="true"
        ></manage-users>
      </div>
    </div>
  </div>

  <!-- Member List -->

  <div class="overflow-sheet-member mt-[12px]">
    <div class="w-full d-flex text-sm font-sans font-semibold">
      Members &nbsp;
      <span class="text-[#25508E] font-bold">({{ isFromManageVault ? nonProfessionalUsers?.length : nonProfessionalUsers?.length + 1 }})</span>
    </div>
    @if(isLoading){
    <div class="loader-container mt-2 w-full" style="flex-direction: column">
      @for (item of loadingItems; track item) {
      <div>
        <div class="flex loader-body w-full" id="{{ item.id }}">
          <div class="ph-item loader-body-item w-full pt-[26px]">
            <div class="ph-col-12 p-0">
              <div class="ph-row">
                <div class="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    }

    <div class="member-infos mt-2 w-full">
      <div
        class="member-infos--left width-100per"
        [ngStyle]="{
          'max-height': switchFromUser
            ? isFromVault
              ? '250px'
              : isFromManageVault
              ? '320px'
              : 'calc(100vh - 528px)'
            : isFromVault
            ? '250px'
            : isFromManageVault
            ? '320px'
            : 'calc(100vh - 475px)',
          'max-width':
            (isFromVault || isFromManageVault) && nonProfessionalUsers?.length > 2
              ? 'calc(100% + 20px)'
              : (isFromVault || isFromManageVault) && nonProfessionalUsers?.length < 3
              ? '100%'
              : ''
        }"
      >
        @if(selectedMember && !isFromManageVault){
        <div
          class="fl-al-center member-infos--add flex fl-justify-between mobile-member-item-view"
          [ngStyle]="{
            'max-width':
              nonProfessionalUsers?.length > 2 && isFromVault ? 'calc(100% - 16px)' : isFromVault && nonProfessionalUsers?.length < 3 ? '100% ' : ''
          }"
        >
          <div class="flex fl-al-center">
            <ngx-avatars
              size="50"
              src="{{ selectedMember?.profile_image_url }}"
              name="{{
                selectedMember?.name
                  ? selectedMember?.name
                  : selectedMember?.nick_name ?? selectedMember?.first_name + ' ' + selectedMember?.last_name
              }}"
              [round]="true"
              initialsSize="2"
            ></ngx-avatars>

            <div class="flex fl-col gap-[2px] ml-[8px]">
              <span class="new-member-infos--name">{{
                selectedMember?.name
                  ? selectedMember?.name
                  : selectedMember?.nick_name ?? selectedMember?.first_name + ' ' + selectedMember?.last_name
              }}</span>
              @if(!professionalVaultCreator){
              <span class="new-member-infos--subname">You</span>
              }
            </div>
          </div>

          <div><span class="type-label mr-[5px]">Owner</span></div>
        </div>
        }
        <div
          *ngFor="let user of nonProfessionalUsers"
          class="flex fl-al-center fl-justify-between w-100per mobile-member-item-view member-infos--add mt-3"
          [ngStyle]="{
            'max-width':
              nonProfessionalUsers?.length > 2 && (isFromVault || isFromManageVault)
                ? 'calc(100% - 16px)'
                : (isFromVault || isFromManageVault) && nonProfessionalUsers?.length < 3
                ? '100% '
                : ''
          }"
        >
          <div class="selected-client-wrapper">
            <div class="flex fl-al-center max-[480px]:items-start">
              <div *ngIf="user?.memberUser?.isGroup">
                <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
              </div>
              @if(user?.memberUser?.name && !user?.memberUser?.user_first_middle_name){
              <ngx-avatars
                *ngIf="!user?.memberUser?.isGroup"
                size="50"
                src="{{ user?.memberUser?.profile_image_url }}"
                name="{{ user?.memberUser?.name }}"
                [round]="true"
                initialsSize="2"
              ></ngx-avatars>
              } @if(user?.memberUser?.user_first_middle_name && !user?.memberUser?.name){
              <ngx-avatars
                *ngIf="!user?.memberUser?.isGroup"
                size="50"
                src="{{ user?.memberUser?.profile_image_url }}"
                name="{{ user?.memberUser?.user_first_middle_name + ' ' + user?.memberUser?.user_last_name }}"
                [round]="true"
                initialsSize="2"
              ></ngx-avatars>
              }

              <div class="flex fl-col gap-[2px] ml-[8px]">
                <span class="new-member-infos--name">{{
                  user?.memberUser?.name ? user.memberUser.name : user?.memberUser?.user_first_middle_name + ' ' + user?.memberUser?.user_last_name
                }}</span>
                <span class="new-member-infos--subname">{{ user?.relationship_name }}</span>
              </div>
            </div>
          </div>
          @if(user.type == "owner"){
          <div><span class="type-label mr-[5px]">Owner </span></div>
          }@else{
          <div class="member-infos--trash flex-center pointer">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon class="menu">more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              @if(allowed_change_owner){
              <button mat-menu-item (click)="updateMember(user, true)">
                <mat-icon style="margin-right: 8px; color: #25508e">person_outline</mat-icon>
                <span class="text-xs font-semibold" style="color: #18191c">Make Owner</span>
              </button>
              }
              <button mat-menu-item (click)="deleteMember(user, true)">
                <img src="assets/images/trash-2.svg" style="margin-right: 12px" alt="trash" />
                <span class="text-xs font-semibold" style="color: #eb5757">Remove</span>
              </button>
            </mat-menu>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</ng-container>
